<template>
  <b-container fluid id="student-attendance" class="mt-4">
    <div class="title">
      <h6>{{ last_name }}, {{ first_name }} -- {{ school }}</h6>
    </div>
    <div id="attendance-table">
      <b-table
        v-cloak
        responsive
        :fields="fields"
        :items="getStudentAttendance"
        :striped="true"
        :bordered="true"
        :hover="true"
        stacked="md"
      >
        <template
          slot="cell(absent)"
          slot-scope="row"
          :class="row.value / row.item.total_days > 0.5 ? 'absent-error' : ''"
          >{{ row.value }}</template
        >
      </b-table>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "StudentAttendance",
  props: {
    first_name: String,
    last_name: String,
    school: String,
  },
  data() {
    return {
      fields: [
        { key: "month_year", label: "Date", sortable: true },
        { key: "present", label: "Days Present", sortable: true },
        { key: "absent", label: "Days Absent", sortable: true },
        {
          key: "total_days",
          label: "Total School Days in Month",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getStudentAttendance: "attendance/getStudentAttendance",
    }),
  },
  methods: {
    ...mapActions({
      GET_ATTENDANCES: "attendance/GET_ATTENDANCE_RECORDS",
    }),
  },
  created() {
    this.GET_ATTENDANCES();
  },
};
</script>
